var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-action"},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button","aria-label":"Izbriši"},on:{"click":function($event){$event.preventDefault();return _vm.deleteItem($event)}}},[_c('i',{staticClass:"fa fa-times text-red",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f8738d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Contacts/Actions/ContactVersionDelete.vue
// module id = Vefa
// module chunks = 0